export default function headerScroll() {
  if ((window.pageYOffset > 10) && (window.innerWidth > 991)) {
    document.querySelector('.header').classList.add('scroll');
  }
  else {
    document.querySelector('.header').classList.remove('scroll');
  }
}



// WEBPACK FOOTER //
// ./scripts/partials/header.js